<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-title" id="pt-1"><a id="page_8"></a><a id="page_9"></a><a id="page_10"><span class="smallcaps">LONDON</span></a></h1><a id="page_10">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Part01.vue?1396e076